import { render } from "./MesasView.vue?vue&type=template&id=e6641fe0&scoped=true"
import script from "./MesasView.vue?vue&type=script&lang=js"
export * from "./MesasView.vue?vue&type=script&lang=js"

import "./MesasView.vue?vue&type=style&index=0&id=e6641fe0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6641fe0"]])

export default __exports__